import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React from "react";
import styles from "../styles/OrdersTable.module.scss";
import { useTranslation } from "react-i18next";

export default function OrdersTable({
  data,
  columns,
  header = null,
  theme,
  height,
}) {
  const { t, i18n } = useTranslation();

  const CustomHeader = () => (
    <div className={styles.customHeader}>
      <span className={styles.leftsideToolbar}></span>
      <span className={styles.rightsideToolbar}></span>
    </div>
  );
  const table = useMaterialReactTable(
    {
      columns,
      data,
      columnResizeMode: "onChange",
      enableSorting: true,
      enableRowVirtualization: true,
      enableRowSelection: false,
      enableColumnOrdering: false,
      enableColumnActions: false,
      enablePagination: false,
      enableStickyHeader: true,
      layoutMode: "grid",
      getRowId: (row) => row.Id,
      state: {
        data,
        showProgressBars: true,
      },
      defaultColumn: {
        maxSize: 150,
        minSize: 30,
      },

      displayColumnDefOptions: {
        "mrt-row-select": {
          size: 30,
          grow: false,
        },
      },

      // muiTableContainerProps: { sx: { maxHeight: '400px' } },
      muiTableBodyCellProps: {
        sx: (theme) => ({
          backgroundColor:
            theme.palette.mode === "dark"
              ? theme.palette.grey[900]
              : theme.palette.grey[50],
        }),
      },
      muiTableContainerProps: {
        sx: {
          minHeight: height ? "20vh" : "20vh",
          maxHeight: height ? "25vh" : "25vh",
          overflowY: "auto",
          "::-webkit-scrollbar": {
            width: "0.4vh",
            height: "0px",
          },
          "::-webkit-scrollbar-track": {
            background: theme === "dark" ? "#1D1D20" : "#FCFCFD",
          },
          "::-webkit-scrollbar-thumb": {
            background: theme === "dark" ? "#3F3F46" : "#CDD5DF",
            zIndex: "0",
          },
          "::-webkit-scrollbar-thumb:hover": {
            background: theme === "dark" ? "#3F3F46" : "#CDD5DF",
          },
        },
      },
      muiTableProps: {
        className: styles.mui_table,
        sx: {
          borderRadius: "0px",
          caption: {
            display: "none",
          },
          borderSpacing: "0 0.8vh",
          borderCollapse: "separate",
        },
      },
      muiTableHeadProps: {
        className: styles.mui_table_head,
      },
      muiTableHeadRowProps: {
        className: styles.mui_table_head_row,
        "&.MuiSvgIcon-root": {
          color: "red",
        },
      },
      muiTableHeadCellProps: {
        className: styles.table_header_cell,
        sx: {
          "&.MuiSvgIcon-root": {
            color: "red",
          },
        },
      },
      muiTableBodyRowProps: ({ row }) => ({
        className: styles.mui_table_body_row,
        sx: {
          backgroundColor:
            row.index % 2 !== 0
              ? theme === "dark"
                ? "var(--background-3) !important"
                : "var(--background-3) !important"
              : "none !important",
        },
      }),
      muiTableBodyProps: {
        className: styles.mui_table_body,
        sx: {
          // '& tr':{
          //     backgroundColor: data.length > 0 ? "var(--background-3) !important": "none !important"
          // },
          sx: {
            overflow: "hidden",
            display: "flex !important",
            flexDirection: "column",
            gap: "1px",
          },
        },
      },
      muiTableBodyCellProps: {
        className: styles.table_body_cell,
        sx: {
          padding: "0px",
          lineHeight: "1vh",
          borderRadius: 0,
        },
      },
      localization: {
        noRecordsToDisplay: (
          <span className={styles.noResultsFound}>{t("NoRecordsResult")}</span>
        ),
        noResultsFound: (
          <span className={styles.noResultsFound}>{t("NoRecordsResult")}</span>
        ),
      },
      renderBottomToolbar: false,
      renderTopToolbar: false,
    },
    [i18n.language]
  );

  return (
    <MaterialReactTable
      table={table}
      rowVirtualizerOptions={{
        overscan: 50,
        estimateSize: () => 60,
      }}
    />
  );
}
